module.exports = __webpack_public_path__ + "img/play_button.1558c0f0.png";